import { render, staticRenderFns } from "./MasterItemSubGroup.vue?vue&type=template&id=4831e575&scoped=true"
import script from "./MasterItemSubGroup.vue?vue&type=script&lang=js"
export * from "./MasterItemSubGroup.vue?vue&type=script&lang=js"
import style0 from "./MasterItemSubGroup.vue?vue&type=style&index=0&id=4831e575&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4831e575",
  null
  
)

export default component.exports